import Logger from "../lib/logger";
import KeenSlider from 'keen-slider';

class PageAboutStory {

	NAME = 'PageAboutStory';

	constructor(dom) {
		this.dom = dom;

		this.sliderDom;
		this.sliderPrevArrowDom = this.dom.querySelector(`[data-page-about-story-prev-arrow]`);
		this.sliderNextArrowDom = this.dom.querySelector(`[data-page-about-story-next-arrow]`);
		this.sliderDom = this.dom.querySelector(`[data-page-about-story-slider]`);
	}

	/**
	 *  init
	 */
	init() {
		Logger.info(`${this.NAME} > init`);

		this.initSlider();
	}

	/**
	 * initSlider - Initialize the slider
	 */
	initSlider() {
		Logger.info(`${this.NAME} > initSlider`);

		if (this.slider) return;

		if (!this.sliderDom) return;

		this.slider = new KeenSlider(
			this.sliderDom,
			{
				loop: true,
				selector: `[data-page-about-story-slide]`,
			},
			[
				// add plugins here
			]
		);

		this.sliderPrevArrowDom?.addEventListener(`click`, (e) => {
			e.preventDefault();
			this.slider.prev();
		});
		this.sliderNextArrowDom?.addEventListener(`click`, (e) => {
			e.preventDefault();
			this.slider.next();
		});
	}
}

export default PageAboutStory;
